import type { AnalyticsAdapter } from "../types";

const isBrowser = typeof window !== "undefined";

// Extend Window interface for dataLayer and GTM
declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
    google_tag_manager?: unknown;
  }
}

export class GTMAdapter implements AnalyticsAdapter {
  private initialized = false;

  init(): void {
    if (!isBrowser || this.initialized) return;

    const gtmId = import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID;
    if (!gtmId) {
      if (import.meta.env.DEV) {
        console.warn("GTM adapter: VITE_GOOGLE_TAG_MANAGER_ID is not set. GTM adapter will not initialize.");
      }
      return;
    }

    // Ensure dataLayer exists (should be created by GTM script, but we'll ensure it)
    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    this.initialized = true;
  }

  page(_: { name?: string; properties?: Record<string, unknown> }): void {
    return;
  }

  track(input: { event: string; properties?: Record<string, unknown> }): void {
    if (!isBrowser) return;
    if (!this.initialized) return this.init();

    if (!window.dataLayer) return;

    window.dataLayer.push({
      event: input.event,
      ...(input.properties ?? {}),
    });
  }

  identify(input: { userId?: string; traits?: Record<string, unknown> }): void {
    if (!isBrowser) return;
    if (!this.initialized) return this.init();

    if (!window.dataLayer) return;

    window.dataLayer.push({
      event: "user_identified",
      user_id: input.userId,
      ...(input.traits ?? {}),
    });
  }

  reset(): void {
    if (!isBrowser) return;
    if (!this.initialized) return this.init();

    if (!window.dataLayer) return;

    window.dataLayer.push({
      event: "user_reset",
    });
  }
}
